import React, { Component } from 'react';
import { Col, Card, CardBody, CardFooter } from 'reactstrap';
import EirValidImage from '../eir-valid-image/EirValidImage';
import FAQ from '../faq/FAQ';
import DeviceNotification from '../eir-device-notification/DeviceNotification';
import OutOfStockEmail from '../out-of-stock-email/OutOfStockEmail';
import { Button } from 'reactstrap';

class EirMBBDeviceListing extends Component {
  constructor(props) {
    super(props);
  }
  getImageURL() {

    var impagePath = "/.galleries/eir/devices/mbb/" + this.props.device.imageName + ".png";

    return impagePath;

  }
  getSelectedVariant() {

    return this.props.device.variants[0];
  }

  getNamewithoutManufacturer() {
    let name = this.props.device.name
    return name.replace(this.props.device.manufacturer, '');

  }

  isInStock() {
    return this.props.device.variants[0].inStock;
  }

  formatPrice() {

    let formattedPrice = this.props.device.fromPrice == null ? this.roundPrice(this.props.device.price) : this.roundPrice(this.props.device.fromPrice);

    if (!formattedPrice) {
      return 'FREE';
    } else {
      return '€' + formattedPrice;
    }
  }
  roundPrice(price) {
    if (price % 1 === 0) {
      return price;
    } else {
      return price.toFixed(2);
    }
  }
  convertFeaturesToFaq() {
    var faqs =
      [
        {
          question: 'KEY FEATURES',
          answer: this.renderFeatures()
        }
      ];

    return faqs;
  }
  renderFeatures() {
    let features = [];

    this.props.device.details.features.forEach((feature) => { features.push(<li>{feature}</li>); })

    return (
      <ul>
        {features}
      </ul>
    );

  }


  renderButton(selectedVariant) {
    if (selectedVariant.inStock) {
      return (
        <form action="/store/orders/update" method="POST">

          <input type="hidden" name="customerType" value="NEW" />
          <input type="hidden" name="mobileOrderType" value="NEW" />
          <input type="hidden" name="submitUrl" value="/store/orders/update" />
          <input type="hidden" name="variantSku" value={selectedVariant.sku} />
          <input type="hidden" name="deviceId" value={this.props.device.id} />

          <Button className="eir-text-secondary btn btn-outline-primary">
            <span >{this.props.ctaText} </span>
          </Button>


        </form>


      );

    } else {
      let outOfStockFormProps = { ...this.props.outOfStockForm, ...{ selectedVariant: selectedVariant }, ...{ device: this.props.device } };

      return (
        <div className='d-flex mb-2 price-list-container'>
          <div className="out-of-stock-container">
            <OutOfStockEmail {...outOfStockFormProps} />
          </div>
        </div>
      );

    }

  }

  render() {
    return (
      <Col lg="6" className="center-div">
        <Card className="eir-mbb-device eir-card-mbb">
          <CardBody className="eir-card-body d-flex">

            <DeviceNotification device={this.props.device} selectedVariant={this.getSelectedVariant()} />

            <Col lg="6" className="d-flex flex-column">


              <div className="eir-fluid-xs-w75 eir-fluid-sm-w75 eir-fluid-md-w75 eir-fluid-lg-w33 mx-auto">


                <EirValidImage className="img-fluid"
                  src={this.getImageURL()}
                  fallbackSrc='/.galleries/eir/devices/handset_not_found.png' />

              </div>


            </Col>
            <Col lg="6" className="d-flex flex-column mbb-top-padding">
              <div>
                <h6 className="text-left text-uppercase text-base-gray mb-md-3">{this.props.device.manufacturer}</h6>
                <h4 className="text-left text-black mb-md-4">{this.getNamewithoutManufacturer()}</h4>
                <p >
                  <h5 className="d-inline-block">
                    <strong className="device-price">
                      {this.props.device.fromPrice != null && <small className="mr-2">DEVICE COST</small>}
                      {this.formatPrice()}
                    </strong>
                  </h5>
                </p>

                {this.renderButton(this.getSelectedVariant())}

              </div>
            </Col>
          </CardBody>

          <FAQ Title="" faqs={this.convertFeaturesToFaq()} collapse="true"/>

        </Card>
      </Col>
    );
  }
}

export default EirMBBDeviceListing;
